export default "__VITE_ASSET__cdd476cc__"